import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './RentalPortalProfileHeaderFooterAddNewText.module.css'

function RentalPortalProfileHeaderFooterAddNewText({ qaName }) {
  const { t } = useTranslation()

  return (
    <Text
      isSecondary
      className={styles.RentalPortalProfileHeaderFooterAddNewText}
      qaName={qaName}
    >
      {t('RentalPortal.ListingProfileFooterAddNewTextKey')}
    </Text>
  )
}

export default RentalPortalProfileHeaderFooterAddNewText
